module.exports = __webpack_public_path__ + "img/三天风险.04399c91.png";